import { render } from "preact";
import { Provider } from "react-redux";
import { App } from "./App";
import { LocalDevelopmentTools } from "./components/LocalDevelopmentTools";
import { store } from "./store/store";
import "@fontsource-variable/inter";
import "./styles.css";

render(
  <Provider store={store}>
    <LocalDevelopmentTools />
    <App />
  </Provider>,
  document.getElementById("app")!,
);
